import { render, staticRenderFns } from "./phonePreview.vue?vue&type=template&id=51b4020e&"
import script from "./phonePreview.vue?vue&type=script&lang=js&"
export * from "./phonePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51b4020e')) {
      api.createRecord('51b4020e', component.options)
    } else {
      api.reload('51b4020e', component.options)
    }
    module.hot.accept("./phonePreview.vue?vue&type=template&id=51b4020e&", function () {
      api.rerender('51b4020e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/project/manage/components/phonePreview.vue"
export default component.exports